// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\UploadDocumentResponse

export type UploadDocumentApiResponse = {
	url: string;
};

export type UploadDocument = {
	url: string;
};

export function hydrateUploadDocument(data: UploadDocumentApiResponse): UploadDocument {
	return { ...data };
}